import React, { useState } from 'react';

const Popover = ({ title, index, text, client, feedback, feedback2 }) => {
    const [opened, setOpened] = useState(false);
    const [openedFeedback, setOpenedFeedback] = useState(false);

    const className = opened ? 'title opened' : 'title';
    const feedbackClassName = openedFeedback ? 'clientFeedback opened' : 'clientFeedback';

    return (
        <div className="popover">
            <div className={className} onClick={() => setOpened(!opened)}>{index + 1}. {title}</div>
            {opened && (
                <div className="popoverText">
                    <span className="text">{text}</span>
                    {(feedback || feedback2) && (
                        <div className={feedbackClassName}>
                            <div
                                className="feedbackText"
                                onClick={() => setOpenedFeedback(!openedFeedback)}
                            >
                                <span>{client}</span>
                            </div>
                            {openedFeedback && (
                                <>
                                    <div className="firstFeedback">{feedback}</div>
                                    <div className="secondFeedback">{feedback2}</div>
                                </>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Popover;
